import { render, staticRenderFns } from "./BaseAgGridFooter.vue?vue&type=template&id=3095657a&"
import script from "./BaseAgGridFooter.vue?vue&type=script&lang=js&"
export * from "./BaseAgGridFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports